// Dependencies
require("webstrap/scaffolding");

// Styles
require("./menu.scss");

var $ = require('jquery');

function debounce(func) {
    var timer;
    return function (event) {
        if (timer) clearTimeout(timer);
        timer = setTimeout(func, 300, event);
    };
}

function adjSubMenu() {
    $(".menu__subnav").removeClass("menu__subnav--right");
    $(".menu__subnav").each(function (index) {
        var offset = $(this).offset();
        var offsetRight = offset.left + $(this).outerWidth();
        var winWidth = $(window).width();
        var diff = winWidth - offsetRight;
        
        if (diff <= 15) {
            $(this).addClass("menu__subnav--right");
        }
    });
}

function adjMenuForScroll() {
    var scroll = $(window).scrollTop();

    if (scroll > 100 && !$(".menu").hasClass("menu--scroll")) {
        $(".menu").addClass("menu--scroll");
    } else if (scroll <= 100 && $(".menu").hasClass("menu--scroll")) {
        $(".menu").removeClass("menu--scroll");
    }
}

$(".menu__nav-main-item").hover(
    function () {
        $(this).find(".menu__nav-main-link").addClass("menu__nav-main-link--active");
        $(this).find(".menu__subnav").addClass("menu__subnav--active");
        adjSubMenu();
    }, function () {
        $(".menu__subnav").removeClass("menu__subnav--active");
        $(".menu__nav-main-link").removeClass("menu__nav-main-link--active");
    }
);

/*
$(".menu__nav-main-link").on("click", function (e) {
    //si jamais ont veux avoir le menu sub en mode click plutot que hover
    if ($(this).next('.menu__subnav').length > 0) {
        e.preventDefault();
        $(".menu__subnav").removeClass("menu__subnav--active");
        $(".menu__nav-main-link").removeClass("menu__nav-main-link--active");
        $(this).addClass("menu__nav-main-link--active");
        $(this).next(".menu__subnav").addClass("menu__subnav--active");
        adjSubMenu();
    }
});*/

$(".menu__nav-main-burger").on("click", function (e) {
    e.preventDefault();

    var offset = $(this).parent().offset();
    var offsetRight = offset.left + $(this).parent().outerWidth();

    $(this).find(".menu__burger").toggleClass("menu__burger--open");
    $(".menu__mobile").toggleClass("menu__mobile--open");
});

$(".menu__mobile-main-item--sub").find(".menu__mobile-main-link").on("click", function (e) {
    e.preventDefault();

    if (!$(this).parent(".menu__mobile-main-item--sub").hasClass("menu__mobile-main-item--subopen")) {
        $(".menu__mobile-main-item--subopen .menu__mobile-sub").slideUp();
        $(".menu__mobile-main-item--sub").removeClass("menu__mobile-main-item--subopen");
        $(this).parent(".menu__mobile-main-item--sub").addClass("menu__mobile-main-item--subopen");
        $(this).parent(".menu__mobile-main-item--sub").find(".menu__mobile-sub").slideDown();
    } else {
        $(".menu__mobile-main-item--subopen .menu__mobile-sub").slideUp();
        $(".menu__mobile-main-item--sub").removeClass("menu__mobile-main-item--subopen");
    }
});

$(window).on("scroll", function (event) {
    adjMenuForScroll();
});

window.addEventListener("resize", debounce(function (e) {
    adjSubMenu();
    $(".menu__burger").removeClass("menu__burger--open");
    $(".menu__mobile").removeClass("menu__mobile--open");
}));
/*
$('html').click(function (event) {
    //si jamais ont veux avoir le menu sub en mode click plutot que hover
    if ($(event.target).hasClass('menu__nav-main-link') || $(event.target).hasClass('menu__subnav'))
        return;
    $(".menu__subnav").removeClass("menu__subnav--active");
    $(".menu__nav-main-link").removeClass("menu__nav-main-link--active");
    
});*/

adjSubMenu();
adjMenuForScroll();



//////////////////
// WEBPACK FOOTER
// ./LeLab.DomaineForget.Web/src/modules/catalog/menu/index.js
// module id = 211
// module chunks = 0